import { render, staticRenderFns } from "./ConversaManifestacao.vue?vue&type=template&id=620c0b37&"
import script from "./ConversaManifestacao.vue?vue&type=script&lang=js&"
export * from "./ConversaManifestacao.vue?vue&type=script&lang=js&"
import style0 from "./ConversaManifestacao.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports